import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  const scrollToPurchase = () => {
    const element = document.getElementById('comprar');
    if (element) element.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative w-full bg-gradient-to-b from-gray-900 via-gray-800 to-gray-900 text-white py-16 md:py-24 overflow-hidden" data-id="element-78">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]" data-id="element-79"></div>

      <div className="max-w-4xl mx-auto px-4 relative z-10 flex flex-col items-center text-center" data-id="element-80">
        {/* Headline */}
        <motion.h1 initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="text-4xl md:text-6xl lg:text-7xl font-bold font-serif leading-tight mb-8 text-white drop-shadow-lg" data-id="element-81">
          Esto no es una <span className="text-red-500 italic" data-id="element-82">crisis</span>.
        </motion.h1>

        {/* Book Mockup */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.8
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="mb-10 cursor-pointer" onClick={scrollToPurchase} data-id="element-83">
          <motion.img src="https://cdn.magicpatterns.com/uploads/hyGMEzjkz1CxPDwztaUAHK/unnamed_(3).jpg" alt="Esto no es una crisis — Portada del libro" className="w-64 md:w-80 drop-shadow-[0_20px_40px_rgba(0,0,0,0.5)] rounded-md" animate={{
          y: [0, -8, 0]
        }} transition={{
          duration: 4,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-84" />
        </motion.div>

        {/* Open book preview */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="mb-10 cursor-pointer" onClick={scrollToPurchase} data-id="element-85">
          <img src="https://cdn.magicpatterns.com/uploads/cQEamf7GwDneTaxUpCnEfX/unnamed_(4).jpg" alt="Esto no es una crisis — Vista interior del libro" className="w-72 md:w-96 drop-shadow-[0_15px_30px_rgba(0,0,0,0.4)] rounded-md opacity-90" data-id="element-86" />
        </motion.div>

        {/* Subtitle / Hook */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="max-w-2xl mx-auto space-y-6 mb-10" data-id="element-87">
          <p className="text-xl md:text-2xl font-medium text-gray-200" data-id="element-88">
            Es ese momento en el que algo adentro tuyo pide{' '}
            <span className="text-amber-400 font-bold" data-id="element-89">
              orden, pausa y claridad
            </span>
            .
          </p>

          <p className="text-lg text-gray-300 leading-relaxed" data-id="element-90">
            Si sentís que estás funcionando, pero no del todo bien… si todo
            sigue igual afuera, pero adentro algo se desacomodó…{' '}
            <span className="text-white font-semibold underline decoration-red-500 decoration-2 underline-offset-4" data-id="element-91">
              este libro es para vos.
            </span>
          </p>

          <div className="flex flex-col md:flex-row items-center justify-center gap-4 text-lg font-medium text-amber-400 bg-gray-800/50 p-4 rounded-lg border border-gray-700" data-id="element-92">
            <span className="flex items-center gap-2" data-id="element-93">
              👉 No para cambiar tu vida.
            </span>
            <span className="hidden md:inline text-gray-600" data-id="element-94">|</span>
            <span className="flex items-center gap-2" data-id="element-95">
              👉 Para acomodarte cuando la vida aprieta.
            </span>
          </div>
        </motion.div>

        {/* CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="w-full" data-id="element-96">
          <CTAButton text="Empezar a leer ahora" subtext="Descarga inmediata • Lectura digital" data-id="element-97" />
        </motion.div>
      </div>
    </section>;
}